import { Injectable } from '@angular/core';
import { QueryEntity, QueryConfig, Order } from '@datorama/akita';
import { Observable } from 'rxjs';
import { LottoWalletState, LottoWalletStore } from './lotto-wallet.store';
import { LottoWalletItem } from './models/lotto-wallet-item.model';

@Injectable({ providedIn: 'root' })
@QueryConfig({ sortBy: 'EndDate', sortByOrder: Order.ASC })
export class LottoWalletQuery extends QueryEntity<LottoWalletState> {
  constructor(protected store: LottoWalletStore) {
    super(store);
  }

  /** All lottos. */
  selectLottoWalletItems(): Observable<LottoWalletItem[]> {
    return this.selectAll();
  }

  /** A specific lotto by ID. */
  selectLottoWalletItem(id: number): Observable<LottoWalletItem | undefined> {
    return this.selectEntity(id);
  }
}
